import { useLocation } from 'react-router'
import { SystemModuleName } from '@/core/types/SystemModuleName.ts'
import { ModuleViewName } from '@/core/types/ModuleViewName.ts'

const useGetCurrentModuleInfo = () => {
  const { pathname } = useLocation()
  const currentModuleName = pathname.split('/')[1] as SystemModuleName
  const currentViewName = pathname.split('/')[2] as unknown as ModuleViewName

  return {
    currentModuleName,
    currentViewName
  }
}

export default useGetCurrentModuleInfo
